import { Undef } from 'types/UtilityTypes';

/**
 * Whether the Load Building tab spinner should show for this carousel sync cycle.
 *
 * Compare `worksheet` against the last *completed* sync worksheet — not one that was
 * merely acknowledged when the effect started. Updating that ref before debounced
 * `syncCarousel` finished caused ENG-7699: a mid-flight `syncCarousel` identity change
 * cleared the spinner and the re-run no longer looked like a worksheet change.
 */
export function shouldShowSharepointCarouselProcessing(args: {
  worksheet: Undef<string>;
  lastCompletedCarouselWorksheet: Undef<string>;
  hasCompletedInitialVisibleCarouselSync: boolean;
}): boolean {
  const worksheet = args.worksheet?.trim() || undefined;
  const isWorksheetChange =
    Boolean(worksheet) && worksheet !== args.lastCompletedCarouselWorksheet;
  const isInitial = !args.hasCompletedInitialVisibleCarouselSync;
  return isInitial || isWorksheetChange;
}
